import styles from "./index.module.scss";
import AvatarC from "../avatar";
import {
  dateFormat,
  formatCurrency
  // pstDateFormat,
} from "../../../utils/utils";
// import { Accordion, AccordionTab } from "primereact/accordion";
import { useNavigate } from "react-router-dom";
import CustomAccordion from "../../dashboard-properties/custom-accordion";
import Like from "../like";
import PriceDropTag from "../pricedrop-tag";

export default function MobileOfferCard({ item, status, loginType }: any) {
  const navigate = useNavigate();

  return (
    <div className={styles.card}>
      <div
        className={styles.box}
        onClick={(e: any) => {
          if (
            e.target.tagName !== "SVG" &&
            e.target.tagName !== "SPAN" &&
            e.target.tagName !== "PATH"
          ) {
            navigate(`/internal/${item?.id}`, {
              state: {
                propertyDetails: item,
                objPropertyDetails: item
              }
            });
          }
        }}
      >
        <div className={styles.imgBox}>
          {/* eslint-disable-next-line jsx-a11y/alt-text */}
          <img
            src={item.posterImage}
            // onError={(e: any) => {
            //   e.target.src = "/images/default-property.jpg";
            //   e.target.alt = "Image not available";
            // }}
          />
          <div
            className={styles.Showing}
            style={{ background: status?.bgColor, color: status?.txtColor }}
          >
            {item?.status}
          </div>
          <div className={styles.like}>
            <Like
              loginType={loginType}
              propertyId={item.id}
              favCount={item.favCount}
              isMobile={true}
              objPropertyDetails={item}
            />
          </div>
        </div>
        <div className={styles.contentBox}>
          <div className={styles.wrapUpper}>
            <div className={styles.addressWrap}>
              <div className={styles.address}>{item?.street}</div>
              <div className={styles.location}>
                {item?.city + ", " + item.state + " " + item.postalcode}
              </div>
            </div>
          </div>
          <div className={styles.bottomWrap}>
            <div className={styles.bidWrap}>
              <div className={styles.bidValue}>
                {formatCurrency(
                  Math.max(
                    ...item?.yourOffers?.map(
                      (offer: { offerAmount: any }) => offer.offerAmount
                    )
                  ),
                  "USD",
                  "en-US",
                  0,
                  0
                )}
              </div>
              <PriceDropTag
                type={loginType}
                priceDrop={item?.priceDrop}
                priceDropDate={item?.priceDropDate}
              />
            </div>
            {item?.acquisitionAgent1[0]?.name && (
              <div className={styles.agentWrap}>
                <AvatarC
                  // image="/images/mobile-agent.png"
                  shape="circle"
                  label={`${item.acquisitionAgent1[0]?.name?.slice(
                    0,
                    1
                  )}${item.acquisitionAgent1[0]?.name
                    ?.split(" ")[1]
                    ?.slice(0, 1)}`}
                />
                <div className={styles.agentTextWrap}>
                  <div className={styles.Agent}>Agent</div>
                  <div className={styles.AgentValue}>
                    {item?.acquisitionAgent1[0]?.name?.split(" ")[0] +
                      " " +
                      item?.acquisitionAgent1[0]?.name?.split(" ")[1]}
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className={styles.dateWrap}>
            <div className={styles.biddateWrap}>
              <div className={styles.date}>Bid Submitted</div>
              <div className={styles.dateValue}>
                {dateFormat(item.date, "MM/DD/YYYY")}{" "}
                <span className={styles.time}>
                  ({dateFormat(item.date, "hh: mm A")})
                </span>
              </div>
            </div>
            {item.offerDueDateAndTime && (
              <div className={styles.biddateWrapDue}>
                <div className={styles.date}>Due date</div>
                <div className={styles.dateValue}>
                  {dateFormat(item.offerDueDateAndTime, "MM/DD/YYYY")}
                </div>
              </div>
            )}
          </div>
          <div className={styles.acc}>
            <CustomAccordion
              header={`Bid History (${item?.yourOffers?.length || 0})`}
              offers={item?.yourOffers || []}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
